// Copy and media for the landing variants. Testimonials are the real clips from the previous sobes.ru landing.

export type LandingAudience = 'applicant' | 'employer'

/**
 * Quick search tags of the landing hero: the professions with the most
 * published vacancies in Novosibirsk (October 2026: официант 86, повар 49,
 * бармен 38, менеджер ресторана 22, бариста 21, хостес 15, кассир 13,
 * администратор 12). Plain words, because the search requires every word of
 * the query and HH role titles («Официант, бармен, бариста») match almost nothing.
 */
export const popularSearches = ['Официант', 'Повар', 'Бармен', 'Бариста', 'Менеджер ресторана', 'Хостес', 'Кассир', 'Администратор']

export const testimonials = [
  { src: 'https://static.sobes.ru/video-feedbacks/1.mp4', name: 'Артём О.', role: 'бариста', quote: 'Получить работу без опыта — реально!' },
  { src: 'https://static.sobes.ru/video-feedbacks/2.mp4', name: 'Матвей М.', role: 'управляющий «Папа Джонс»', quote: 'Работа без сюрпризов — на sobes.ru' },
  { src: 'https://static.sobes.ru/video-feedbacks/3.mp4', name: 'София А.', role: 'бариста', quote: 'Получила оффер за увлечённость делом.' },
  { src: 'https://static.sobes.ru/video-feedbacks/4.mp4', name: 'Анастасия Л.', role: 'менеджер ресторана', quote: 'Заявляйте об амбициях. Получайте нужные офферы.' },
  { src: 'https://static.sobes.ru/video-feedbacks/5.mp4', name: 'Любовь В.', role: 'хостес', quote: 'Удобный формат — быстрый результат!' },
  { src: 'https://static.sobes.ru/video-feedbacks/6.mp4', name: 'Дмитрий М.', role: 'повар', quote: 'Уверенность + харизма в видео = работа мечты.' },
  { src: 'https://static.sobes.ru/video-feedbacks/7.mp4', name: 'Варвара О.', role: 'официантка', quote: 'Без опыта — нашла работу через 2 дня.' },
]

export const steps: Record<LandingAudience, { title: string, text: string }[]> = {
  applicant: [
    { title: 'Запиши видео о себе', text: 'Минута на телефон — без резюме и опыта. Расскажи, кто ты, когда можешь работать и что тебе нравится.' },
    { title: 'Листай вакансии рядом', text: 'Кофейни, рестораны и магазины сами показывают зал, команду и смены. Понравилось — откликайся в один тап.' },
    { title: 'Выходи на смену', text: 'Работодатель пишет в чат, договариваетесь о встрече — и ты уже в команде.' },
  ],
  employer: [
    { title: 'Сними вакансию в зале', text: 'Покажи место, команду и график на телефон. Кандидат сразу поймёт, подходит ли ему работа.' },
    { title: 'Смотри кандидатов', text: 'Улыбку, речь и энергию видно за минуту — для работы с гостями это важнее строчек опыта.' },
    { title: 'Закрой смену быстрее', text: 'Пиши подходящим кандидатам в чат и зови на стажировку без лишних созвонов.' },
  ],
}

export const faq: Record<LandingAudience, { q: string, a: string }[]> = {
  applicant: [
    { q: 'Чем видеорезюме лучше обычного?', a: 'Видео показывает коммуникабельность, энтузиазм и манеру общения — то, что не передать текстом. Так проще выделиться среди других кандидатов.' },
    { q: 'Кто увидит моё видео?', a: 'Видимость резюме можно отключить в поиске или открыть доступ только по ссылке. Контакты видят только работодатели, которые вас пригласили.' },
    { q: 'Сколько это стоит?', a: 'Для соискателей Sobes бесплатен: создавайте и храните видеорезюме без каких-либо затрат.' },
    { q: 'У меня нет опыта. Меня возьмут?', a: 'Да. В кафе, ресторанах и магазинах часто важнее улыбка, энергия и желание работать, а это как раз видно на видео.' },
    { q: 'Я стесняюсь камеры. Что делать?', a: 'Перезаписывайте сколько угодно раз. Минута честного рассказа работает лучше, чем идеальный текст.' },
  ],
  employer: [
    { q: 'Чем Sobes лучше обычных сайтов вакансий?', a: 'Вы видите кандидата до встречи: как он говорит, улыбается и держится. Для бариста, официанта или продавца это важнее резюме — меньше пустых собеседований и неявок.' },
    { q: 'Подойдёт ли Sobes небольшой кофейне или сети?', a: 'Да. Одна точка или десяток — видеовакансию можно снять на телефон за пару минут и разместить сразу.' },
    { q: 'Какие инструменты доступны?', a: 'Видеовакансии, лента и поиск видеорезюме, отклики и чат с кандидатами.' },
    { q: 'Сколько стоит размещение?', a: 'Сейчас платформа работает в бета-режиме, размещение бесплатное.' },
    { q: 'Есть ли успешные кейсы?', a: 'Да — посмотрите видеоотзывы выше или напишите нам на offer@sobes.ru, расскажем подробнее.' },
  ],
}


const pluralRules = new Intl.PluralRules('ru-RU')
const vacancyForms: Partial<Record<Intl.LDMLPluralRule, string>> = { one: 'вакансия', few: 'вакансии', many: 'вакансий' }

export function vacanciesWord(count: number): string {
  return vacancyForms[pluralRules.select(count)] ?? 'вакансий'
}
